Vue.component("SidePanel", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition :name="sidepanelEntranceName">
            <div class="side-panel" :style="{right: align == 'right' ? 0 : 'auto'}" v-if="open">
                <div class="side-panel__top">
                    <h1 class="side-panel__title">Side Panel Example</h1>
                    <div @click="close" class="side-panel__btnClose">&times;</div>
                </div>
                
                <ul class="side-panel__navigation"> 
                    <li v-for="(nav, i) in slides"
                    :class="{'side-panel__navigation--active': activetab == i}" 
                    @click="changeTab(i)">{{nav.title}}</li>
                </ul>
                
                <transition-group :name="contentTransitionName" tag="section" class="side-panel__content">
                    <div v-for="(content, i) in slides"
                    v-show="activetab == i"
                    :key="content.title">
                    
                        <img class="side-panel__content__poster" v-if="content.poster.endsWith('jpg') || content.poster.endsWith('png')" :src="content.poster">
                        <video class="side-panel__content__poster" autoplay loop type="video/mp4" v-if="content.poster.endsWith('mp4')">
                            <source :src="content.poster">
                        </video>
                        
                        <section class="side-panel__content__text">
                            <h2 v-html="content.title"></h2>
                            <p v-html="content.text"></p>
                        </section> 
                    </div>
                </transition-group>
            </div>
        </transition>
    `,
    data() {
        return {
            activetab: 0,

            // content
            slides: [],
            
            // customization variables
            align: "left",

            // variables for this instance of the sidepanel
            open: false,
            sidepanelEntranceName: "sidepanelentranceleft",
            contentTransitionName: "contentslideright"
        }
    },
    mounted() {
        this.animateEntrance();
    },
    methods: {
        animateEntrance() {
            // animate entrance of component based on which side of the scene it enters.
            this.sidepanelEntranceName = this.align == "left" ? "sidepanelentranceleft" : "sidepanelentranceright"
            this.open = true;
        },
        changeTab(i) {
            // animate change in componentm slides based on what direction the next slide is in.
            this.contentTransitionName = this.activetab < i ? "contentslideright" : "contentslideleft";
            this.activetab = i;
        },
    }
})

touchKit.ComponentManager.register("SidePanel", {singleton: false});